import $ from "jquery";
import size from '../base/_size';
import debug from 'bows/dist/bows.min.js';


let $featured = $('[data-slider="featured"]');

const $body = $('body');
const log = debug("sliders:featured");


function setControls($self, $sn) {
  let currentImageHeight = $self.find('img').height();
  // look for blank images. Featured images have a min height of 20px
  if ( currentImageHeight > 20 ) {
    $sn.css('top', currentImageHeight / 2);
  }
}

function sliderInit() {

  $featured.each(function () {
    let $this = $(this);
    let role = $this.attr('role');
    let $featured = $this.closest('.slider-contain');
    let $sn = $featured.find('.slider-nav');
    let $sb = $featured.find('.slider-nav__arrows');

    if (role !== 'region') {
      let $slider = $this.slick({
        dots: false,
        mobileFirst: true,
        speed: 500,
        infinite: true,
        variableWidth: false,
        slidesToShow: 1,
        arrows: true,
        appendArrows: $sb,
        slidesToScroll: 1,
        touchThreshold: 20,
        autoplay: true,
        autoplaySpeed: 10000,
      });

      setTimeout(() => {
        setControls($this.find('.slick-current'), $sn);
      }, 100);

      $slider.on('afterChange', function (event, slick, currentSlide) {
        setControls($this.find(`[data-slick-index="${currentSlide}"]`), $sn);
      });

      $(window).on('resize', function () {
        setTimeout(() => {
          setControls($this.find('.slick-current'), $sn);
        }, 100);
      }).on('load', function () {
        setControls($this.find('.slick-current'), $sn);
      });
    }
  });
}


export function init() {
  if ($featured.length) {
    sliderInit();
  }
}

export default {
  init
};
